import { Plus, Chat, Trash, X } from '@phosphor-icons/react';

export const SessionSidebar = ({ sessions, activeSession, onSelect, onNew, onDelete, open, onClose }) => (
  <>
    {/* Mobile overlay */}
    {open && (
      <div className="sm:hidden fixed inset-0 bg-black/30 z-40" onClick={onClose} />
    )}

    <div
      className={`
        fixed sm:relative top-0 left-0 h-full w-64 bg-white border-r border-[#f2f4f6] flex flex-col z-50 transition-transform duration-200
        ${open ? 'translate-x-0' : '-translate-x-full sm:translate-x-0'}
      `}
      data-testid="session-sidebar"
    >
      {/* Header */}
      <div className="p-4 border-b border-[#f2f4f6] flex items-center justify-between">
        <h3 className="font-bold text-sm text-[#2d3338]">Conversations</h3>
        <div className="flex items-center gap-1">
          <button
            onClick={onNew}
            className="p-2 rounded-lg hover:bg-[#f2f4f6] transition-colors"
            data-testid="new-chat-btn"
          >
            <Plus size={16} weight="bold" className="text-[#596065]" />
          </button>
          <button onClick={onClose} className="sm:hidden p-2 rounded-lg hover:bg-[#f2f4f6]">
            <X size={16} weight="bold" className="text-[#596065]" />
          </button>
        </div>
      </div>

      {/* Sessions list */}
      <div className="flex-1 overflow-y-auto p-2 space-y-1">
        {sessions.length === 0 && (
          <p className="text-xs text-[#acb3b8] text-center py-8">No conversations yet</p>
        )}
        {sessions.map((s) => (
          <div
            key={s.session_id}
            className={`group flex items-center gap-2 rounded-lg px-3 py-2.5 cursor-pointer transition-colors ${
              activeSession === s.session_id
                ? 'bg-[#0f172a] text-white'
                : 'hover:bg-[#f2f4f6] text-[#596065]'
            }`}
            onClick={() => { onSelect(s.session_id); onClose(); }}
            data-testid={`session-${s.session_id}`}
          >
            <Chat size={14} weight={activeSession === s.session_id ? 'fill' : 'regular'} className="flex-shrink-0" />
            <span className="text-xs truncate flex-1">{s.preview || 'New conversation'}</span>
            <button
              onClick={(e) => { e.stopPropagation(); onDelete(s.session_id); }}
              className={`opacity-0 group-hover:opacity-100 p-1 rounded transition-opacity ${
                activeSession === s.session_id ? 'hover:bg-white/10' : 'hover:bg-[#e2e8f0]'
              }`}
              data-testid={`delete-session-${s.session_id}`}
            >
              <Trash size={12} />
            </button>
          </div>
        ))}
      </div>
    </div>
  </>
);
